import axios from 'axios';

export const TOGGLE_MENU_VISIBILITY = 'TOGGLE_MENU_VISIBILITY';
export const TOGGLE_INFO_VISIBILITY = 'TOGGLE_INFO_VISIBILITY';

// apiURL, jsonURL
export const SET_API_URLS = 'SET_API_URLS';

// timer events to start and stop timer and / or countdown
// timerZero
export const START_TIMER = 'START_TIMER';
// timerConstant
export const SET_TIMER_CONSTANT = 'SET_TIMER_CONSTANT';

// visibility: hidden, visible, beforeZero, afterZero
export const SET_TIMER_VISIBILITY = 'SET_TIMER_VISIBILITY';

// chart area visibility change 
export const TOGGLE_CHART_VISIBILITY = 'TOGGLE_CHART_VISIBILITY';

// map
export const SET_MAP = 'SET_MAP';

// when adding layers to the map
export const SET_MAP_LAYERS = 'SET_MAP_LAYERS';

// when the map reached idle state first
export const MAP_FIRST_IDLE_TIME = 'MAP_FIRST_IDLE_TIME';

// style (with satellite, terrain, ... base styles)
export const SET_MAP_STYLE = 'SET_MAP_STYLE';
export const MAP_STYLE_LOADING = 'MAP_STYLE_LOADING';
// export const MAP_STYLE_LOADED = 'MAP_STYLE_LOADED';

// for lazy loading json defined map layers: 
// itemKey, itemGeoJson
export const FETCH_GEOJSON_REQUEST = 'FETCH_GEOJSON_REQUEST'
export const FETCH_GEOJSON_SUCCESS = 'FETCH_GEOJSON_SUCCESS';
export const FETCH_GEOJSON_ERROR = 'FETCH_GEOJSON_ERROR';

// global time for playback: 
export const SET_DISPLAY_TIME = 'SET_DISPLAY_TIME'
// playback state: 'playing' or 'paused' 
export const SET_PLAYBACK_STATE = 'SET_PLAYBACK_STATE'

//
export const SET_VIEWPORT_ITEM_ZOOM_TO = 'SET_VIEWPORT_ITEM_ZOOM_TO';

export function fetchGeoJson(itemKey, geoJsonUrl) {
  return (dispatch, getState) => {
    dispatch({type: FETCH_GEOJSON_REQUEST, itemKey: itemKey, geoJsonUrl: geoJsonUrl })
    axios.get(geoJsonUrl)
    .then( response => {
      dispatch( {
        type: FETCH_GEOJSON_SUCCESS,
        itemKey: itemKey, geoJsonUrl: geoJsonUrl, 
        geoJson: response.data
      } )
    })
    .catch( error => {
      dispatch( { type: FETCH_GEOJSON_ERROR,
        itemKey: itemKey, geoJsonUrl: geoJsonUrl,
        error: error } )
    })
    // .then( response => {   })
  
  }
}

export function setZoomToItem(viewportItemId) {
  return (dispatch, getState) => {
    // first set visibility state, then schedule fetching data
    dispatch( {
      type: SET_VIEWPORT_ITEM_ZOOM_TO,
      viewportItemId: viewportItemId
    } )
  }
}
